import IntelligenceLanding from "@/components/landing/IntelligenceLanding";
import { Landmark, ShieldCheck, ClipboardList, Network } from "lucide-react";

export default function ForAgencies() {
  return (
    <IntelligenceLanding
      audience="agencies"
      eyebrow="For Agencies & Public Institutions"
      title="A live operating picture of the communities you serve."
      subtitle="Track legislation, funder activity, DBE pipeline, and partner readiness across Alabama — in one place, with the citations and methodology to back every number."
      bullets={[
        {
          icon: Landmark,
          title: "Legislation intelligence",
          body: "Live tracking of Alabama bills, sponsors, and county-level impact — with citations on every record.",
        },
        {
          icon: ClipboardList,
          title: "Program dashboards",
          body: "Procurement, DBE, and community impact metrics surfaced from the same data your partners contribute.",
        },
        {
          icon: Network,
          title: "Partner network access",
          body: "Verified directory of minority-led firms, advocates, and community partners across all 67 counties.",
        },
        {
          icon: ShieldCheck,
          title: "Methodology you can defend",
          body: "Every figure is sourced and reproducible — built for procurement, audits, and inter-agency review.",
        },
      ]}
      pricingNote="Intelligence tier — $2,500/mo. Annual discount available."
    />
  );
}